<script setup lang="ts">
    import type { Asset, BackgroundColorsPredefined, ProductBadgeData } from '~/@types/cms';

    declare interface HighlightProps {
        hero: Asset;
        title: string | undefined;
        content: string | undefined;
        link?: Link;
        background: BackgroundColorsPredefined;
        odd: boolean;
        productBadge?: ProductBadgeData;
    }
    defineProps<HighlightProps>();
</script>

<template>
    <atm-grid
        class="mol-highlight mb-12"
        :no-margin="background === 'default'">
        <div class="col-span-2 flex justify-center overflow-hidden rounded-lg bg-white md:col-span-6 lg:col-span-8">
            <atm-asset
                :data="hero"
                class="max-h-[75vh] lg:min-h-72" />
        </div>
        <div :class="['col-span-2 flex flex-col justify-center gap-4 max-md:mb-6 md:col-span-6 lg:col-span-4', { 'md:order-first': odd }]">
            <lazy-atm-heading
                v-if="title"
                level="h4">
                <renderer-html :content="woomTextFormat(title)" />
            </lazy-atm-heading>
            <div v-if="content">
                <renderer-html :content="content" />
            </div>

            <component
                v-if="productBadge?.product_badge"
                :is="badgeIcon(productBadge?.product_badge)"
                class="h-12 w-12" />

            <atm-link
                v-if="link"
                :link="link"
                kind="link"
                styling="solid-secondary">
                {{ link?.label }}
            </atm-link>
        </div>
    </atm-grid>
</template>

<style scoped>
    .mol-highlight :deep(img) {
        @apply max-h-full;
    }
</style>
